module.exports = {"ratingSizes":{"size10":10,"size18":18,"size24":24,"size36":36}}